import React from "react";

export const PortUsbAnime = () => {
  return (
    <>
      <svg
        width="70"
        height="25"
        viewBox="0 0 70 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_60_1644)">
          <rect x="4" width="62" height="12" fill="white" />
          <path d="M4 12H66L65 17H5L4 12Z" fill="#8C8C8C" />
        </g>
        <defs>
          <filter
            id="filter0_d_60_1644"
            x="0"
            y="0"
            width="70"
            height="25"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_60_1644"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_60_1644"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
